import { resolveUpgradeEmail } from './resolve-upgrade-email'

const appt = (cartEmail, orderEmail) => ({
  cart: cartEmail === undefined ? undefined : { email: cartEmail },
  order: orderEmail === undefined ? undefined : { email: orderEmail },
})

describe('resolveUpgradeEmail', () => {
  it('prefers the state email when present', () => {
    expect(resolveUpgradeEmail('typed@x.com', appt('cart@x.com', 'order@x.com'))).toBe('typed@x.com')
  })

  it('falls back to the appointment cart email when state is blank (the React-17 race)', () => {
    // The auto-upgrade fires before setEmail lands -> emailState is ''. Must still resolve.
    expect(resolveUpgradeEmail('', appt('cart@x.com', 'order@x.com'))).toBe('cart@x.com')
  })

  it('falls back to the order email when the cart has none', () => {
    expect(resolveUpgradeEmail('', appt('', 'order@x.com'))).toBe('order@x.com')
    expect(resolveUpgradeEmail('', appt(undefined, 'order@x.com'))).toBe('order@x.com')
  })

  it('returns empty string when nothing is available (no crash on missing appointment)', () => {
    expect(resolveUpgradeEmail('', null)).toBe('')
    expect(resolveUpgradeEmail('', appt(undefined, undefined))).toBe('')
  })

  it('trims whitespace', () => {
    expect(resolveUpgradeEmail('  a@b.com  ', null)).toBe('a@b.com')
    expect(resolveUpgradeEmail('', appt('  c@d.com ', null))).toBe('c@d.com')
  })
})
